module.exports = __webpack_public_path__ + "240ea841275de10cf5e0391e5af9673f.svg";